import { openModal } from "./actions/openModal"
import { closeModal } from "./actions/closeModal"

export const actions = {
    openModal: openModal,
    closeModal: closeModal,
};